import { DeleteWithToken, GetWithToken, PostWithToken, PatchWithToken } from "../../lib/request";

export const createNewPage = (data) => {
    return async function (dispatch) {
        const result = await PostWithToken('/v2/admin/pages', data);
        return result;
    }
}

export const getAllPages = (query) => {
    return async function (dispatch) {
        const limit = query?.limit || 10;
        const offset = query?.offset || 0;
        const type = query?.type ? `&type=${query.type}` : '';
        const status = query?.status ? `&status=${query.status}` : '';
        const result = await GetWithToken(`/v2/admin/pages?limit=${limit}&offset=${offset}${type}${status}`);
        return result;
    }
}

export const getPageById = (id) => {
    return async function (dispatch) {
        const result = await GetWithToken(`/v2/admin/pages/${id}`);
        return result;
    }
}

export const updatePageById = (id, data) => {
    return async function (dispatch) {
        const result = await PatchWithToken(`/v2/admin/pages/${id}`, data);
        return result;
    }
}

export const deletePageById = (id) => {
    return async function (dispatch) {
        const result = await DeleteWithToken(`/v2/admin/pages/${id}`);
        return result;
    }
}
